export default {
  //两个REJECTED
  "UNPAID": "UNPAID",
  "PAID": "PAID",
  "SUBMITTED": "SUBMITTED",
  "PENDING": "PENDING",
  "VERIFIED": "VERIFIED",
  "REJECTED": "REJECTED",
  "CANCELED": "CANCELED",
  "DISABLED": "DISABLED",
  "PENDING_PAY": "PENDING_PAY",

  "GENERAL": "GENERAL",
  "FEEITEM": "FEEITEM",
  "EDITPRICE": "EDITPRICE",
  "DISCOUNT": "DISCOUNT",
  "REFUND": "REFUND",
  "DEDUCTION": "DEDUCTION",
  "COUPON": "COUPON",



  "REFUNDING": "REFUNDING",
  "REFUNDED": "REFUNDED",
  "COMPLETED": "COMPLETED",
  "FINISH": "FINISH",
  "IN_PROCESS": "IN_PROCESS",

  '基础版': 'Basic Edition',
  '升级版': 'Upgraded version',
  '豪华版': 'Deluxe Edition',

  'EXPORTED': 'EXPORTED',
  'UNEXPORTED': 'UNEXPORTED',
  'APPLYED': 'APPLYED',

  'UP_PC': 'ONLINE',
  'CASH': 'CASH',
  'BALANCE': 'BALANCE',
  'REMITTANCE': 'WIRE',
  'CLOUDBILL': 'CLOUDBILL',
  'WX_MP': 'MINIAPPS',
  'WX_QR': 'WECHAT',
  'ALI_PC': 'ALIPAY',
  'WX_BC': 'WECHAT MICROPAY',
  'ALI_BC': 'ALIPAY MICROPAY',
  'ALI_H5': 'ALIPAY WAP',
  'WX_H5': 'WECHAT H5',
  'ON_SITE': 'ON SITE',
  '未选择支付方式': 'NO PAYMENT METHODS',

  'NOT_SEND': 'Not delivered',
  'HAVE_ACCEPTED': 'Accepted',
  'HAVE_SEND': 'Delivered',

  'LOCAL': 'LOCAL',
  'NOLOCAL': 'NOLOCAL',

}



// WEBPACK FOOTER //
// ./src/i18n/en-us/dataI18n/status.js